module.exports = {"id":"220414","name":"Diego Rico","rating":"76","photo":"./data/images/photos/0/220414.png","club":{"name":"CD Leganés","logo":"./data/images/clubs/CDLeganes.png"},"positions":["DG","DLG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DiegoRico0.json
// module id = 1094
// module chunks = 0